import {animate, group, query, stagger, style, transition, trigger} from '@angular/animations';

export const fade = trigger('fade', [
	transition('* <=> *', [
		/* order */
		/* 1 */ query(':enter, :leave', style({position: 'absolute', width: '100%', 'padding-right': '30px'})
			, {optional: true}),
		/* 2 */ group([  // block executes in parallel
			query(':leave', [
				style({opacity: 0}),
			], {optional: true}),
		]),
		query(':enter', [
			style({opacity: 0}),
			animate('0.5s ease-in-out', style({opacity: 1})),
		], {optional: true}),

	]),
]);
export const enterAnimation = trigger(
	'enterAnimation', [
		transition(':enter', [
			style({opacity: 0}),
			animate('250ms ease-in-out', style({opacity: 1})),
		]),
		transition(':leave', [
			style({opacity: 1}),
			animate('500ms ease-in-out', style({opacity: 0})),
		]),
	],
);
export const onlyEnterAnimation = trigger(
	'onlyEnterAnimation', [
		transition(':enter', [
			style({opacity: 0}),
			animate('250ms ease-in-out', style({opacity: 1})),
		]),
	],
);
export const listStagger = trigger('listStagger', [
	transition('* <=> *', [
		query(
			':enter, .animate',
			[
				style({opacity: 0, transform: 'translateX(50px)'}),
				stagger(
					'50ms',
					animate(
						'250ms ease-out',
						style({opacity: 1, transform: 'translateX(0px)'}),
					),
				),
			],
			{optional: true},
		),
		query(':leave, .animate', animate('50ms', style({opacity: 0})), {
			optional: true,
		}),
	]),
]);
export const fastListStagger = trigger('fastListStagger', [
	transition('* <=> *', [
		query(
			':enter, .animate',
			[
				style({opacity: 0, transform: 'translateX(50px)'}),
				stagger(
					'20ms',
					animate(
						'250ms ease-out',
						style({opacity: 1, transform: 'translateX(0px)'}),
					),
				),
			],
			{optional: true},
		),
		query(':leave, .animate', animate('50ms', style({opacity: 0})), {
			optional: true,
		}),
	]),
]);
